import { Association } from './assoication';

export class IndividualAffiliationModel {
  public IsAffinity: Association[] = [];
  public ixo_key: string = undefined;
  public ixo_start_date: Date = undefined;
  public ixo_end_date: Date = undefined;
  public ixo_add_date: Date = undefined;
  public ixo_title: string = undefined;
  public ixo_primary_affinity_flag_ext: boolean = undefined;
  public rlt_code: string = undefined;
  public rlt_flow_down: boolean = undefined;
  public rlt_org_area_access_flag: boolean = undefined;
  public rlt_org_area_access_edit_flag: boolean = undefined;
  public cst_recno: number = undefined;
  public org_name: string = undefined;
  public org_ogt_code: string = undefined;
  public org_group_aie_flag_ext: boolean = undefined;
  public org_require_aie_flag_ext: boolean = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'ixo_start_date':
            case 'ixo_end_date':
            case 'ixo_add_date':
              const dateKey: 'ixo_start_date' | 'ixo_end_date' | 'ixo_add_date' = key as any;
              if (source[dateKey] == null || source[dateKey] === undefined || source[dateKey] === '') {
                this[dateKey] = null;
              } else {
                this[dateKey] = new Date(source[dateKey]);
              }
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
